import React from "react";
import { X, Shield } from "lucide-react";

const PrivacyPolicy = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div 
      className="fixed inset-0 z-[100] bg-black/60 backdrop-blur-sm flex items-start justify-center overflow-y-auto py-8 px-4"
      onClick={onClose}
      data-testid="privacy-modal-overlay"
    >
      <div 
        className="bg-white rounded-3xl max-w-4xl w-full relative my-4"
        onClick={(e) => e.stopPropagation()}
        data-testid="privacy-modal"
      >
        {/* Header */}
        <div className="sticky top-0 z-10 bg-white rounded-t-3xl border-b border-slate-200 px-8 py-6 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl bg-gradient-to-r from-teal-500/10 to-emerald-500/10 flex items-center justify-center">
              <Shield className="w-5 h-5 text-teal-600" />
            </div>
            <h2 className="text-2xl font-medium font-['Outfit'] text-slate-900">Privacy Policy</h2>
          </div>
          <button 
            onClick={onClose}
            className="w-10 h-10 rounded-full bg-slate-100 flex items-center justify-center hover:bg-slate-200 transition-colors"
            data-testid="privacy-close-btn"
          >
            <X className="w-5 h-5 text-slate-600" />
          </button>
        </div>

        {/* Content */}
        <div className="px-8 py-8 prose prose-slate max-w-none">
          <p className="text-sm text-slate-500 mb-6">
            Informativa sul trattamento dei dati personali ai sensi del Regolamento (UE) 2016/679 ("GDPR")<br />
            Ultimo aggiornamento: 17/04/2026
          </p>

          <h3 className="text-lg font-medium font-['Outfit'] text-slate-900 mt-8 mb-3">1. Titolare del trattamento</h3>
          <p className="text-slate-600 leading-relaxed">
            Il Titolare del trattamento è il <strong>Dott. Enrico Bruni</strong>, con studio in Corso Torino 15/3, 16129 Genova, P.IVA 02295490995.
          </p>
          <p className="text-slate-600 leading-relaxed">Recapiti del Titolare:</p>
          <ul className="text-slate-600 space-y-1 list-disc pl-6">
            <li>E-mail: studiodrbruni@gmail.com</li>
            <li>Telefono: 347 102 1765</li>
          </ul>

          <h3 className="text-lg font-medium font-['Outfit'] text-slate-900 mt-8 mb-3">2. Tipologia di dati trattati</h3>
          <p className="text-slate-600 leading-relaxed">Attraverso il presente sito internet possono essere trattati:</p>
          <ul className="text-slate-600 space-y-2 list-disc pl-6">
            <li>dati identificativi e di contatto, quali nome, cognome, numero di telefono, indirizzo e-mail;</li>
            <li>dati contenuti nei messaggi inviati spontaneamente dall'utente tramite modulo di contatto, e-mail, telefono o altri canali indicati nel sito;</li>
            <li>dati tecnici di navigazione, quali indirizzo IP, data e ora di accesso, tipo di browser, sistema operativo, informazioni sul dispositivo, pagine visitate;</li>
            <li>eventuali ulteriori dati comunicati spontaneamente dall'utente.</li>
          </ul>
          <div className="bg-amber-50 border border-amber-200 rounded-xl p-4 mt-4">
            <p className="text-amber-800 text-sm leading-relaxed">
              <strong>Avvertenza importante:</strong> l'utente è invitato a non inserire nel modulo di contatto informazioni cliniche dettagliate o dati relativi alla salute, salvo ciò sia strettamente necessario e richiesto. Eventuali dati sanitari dovranno essere preferibilmente raccolti e trattati nel contesto del rapporto sanitario con modalità adeguate e proporzionate.
            </p>
          </div>

          <h3 className="text-lg font-medium font-['Outfit'] text-slate-900 mt-8 mb-3">3. Finalità del trattamento</h3>
          <p className="text-slate-600 leading-relaxed">I dati personali raccolti attraverso il sito sono trattati per le seguenti finalità:</p>
          <ol className="text-slate-600 space-y-2 list-[lower-alpha] pl-6">
            <li>rispondere a richieste di informazioni inviate dall'utente;</li>
            <li>ricontattare l'utente telefonicamente o via e-mail;</li>
            <li>gestire eventuali richieste di appuntamento o di primo contatto con lo studio;</li>
            <li>garantire il corretto funzionamento tecnico del sito, la sicurezza dei sistemi e la prevenzione di abusi;</li>
            <li>adempiere a obblighi previsti dalla legge, da regolamenti o da richieste dell'autorità competente;</li>
            <li>accertare, esercitare o difendere un diritto del Titolare.</li>
          </ol>

          <h3 className="text-lg font-medium font-['Outfit'] text-slate-900 mt-8 mb-3">4. Base giuridica del trattamento</h3>
          <p className="text-slate-600 leading-relaxed">Il trattamento dei dati si fonda sulle seguenti basi giuridiche:</p>
          <ul className="text-slate-600 space-y-2 list-disc pl-6">
            <li>misure precontrattuali adottate su richiesta dell'interessato, quando l'utente contatta lo studio per ricevere informazioni o richiedere un appuntamento;</li>
            <li>interesse legittimo del Titolare, per la sicurezza del sito, la prevenzione di accessi abusivi e la gestione tecnica della piattaforma;</li>
            <li>adempimento di obblighi di legge, ove applicabile;</li>
            <li>consenso dell'interessato, solo nei casi in cui ciò sia richiesto dalla normativa applicabile.</li>
          </ul>

          <h3 className="text-lg font-medium font-['Outfit'] text-slate-900 mt-8 mb-3">5. Natura del conferimento dei dati</h3>
          <p className="text-slate-600 leading-relaxed">
            Il conferimento dei dati richiesti nei moduli di contatto o nelle richieste inviate spontaneamente è facoltativo, ma necessario per poter ricevere risposta. L'eventuale mancato conferimento dei dati indispensabili può rendere impossibile dare seguito alla richiesta.
          </p>

          <h3 className="text-lg font-medium font-['Outfit'] text-slate-900 mt-8 mb-3">6. Modalità del trattamento</h3>
          <p className="text-slate-600 leading-relaxed">
            Il trattamento dei dati è effettuato con strumenti cartacei, informatici e telematici, nel rispetto dei principi di liceità, correttezza, trasparenza, minimizzazione, integrità e riservatezza. Il Titolare adotta misure tecniche e organizzative adeguate per proteggere i dati personali da accessi non autorizzati, perdita, distruzione, divulgazione indebita o uso illecito.
          </p>

          <h3 className="text-lg font-medium font-['Outfit'] text-slate-900 mt-8 mb-3">7. Destinatari dei dati</h3>
          <p className="text-slate-600 leading-relaxed">I dati personali possono essere trattati da:</p>
          <ul className="text-slate-600 space-y-2 list-disc pl-6">
            <li>personale autorizzato dal Titolare;</li>
            <li>fornitori di servizi informatici, hosting, manutenzione tecnica e sicurezza del sito;</li>
            <li>consulenti o professionisti che assistono il Titolare nella gestione amministrativa, legale o tecnica;</li>
            <li>autorità pubbliche o enti competenti nei casi previsti dalla legge.</li>
          </ul>
          <p className="text-slate-600 leading-relaxed mt-2">
            Tali soggetti trattano i dati, a seconda dei casi, in qualità di responsabili del trattamento o di autonomi titolari.
          </p>

          <h3 className="text-lg font-medium font-['Outfit'] text-slate-900 mt-8 mb-3">8. Hosting e servizi tecnici</h3>
          <p className="text-slate-600 leading-relaxed">
            Il sito è ospitato su infrastrutture tecniche fornite da terzi. I relativi fornitori possono trattare dati tecnici e di navigazione nella misura necessaria all'erogazione del servizio, alla sicurezza e alla manutenzione.
          </p>

          <h3 className="text-lg font-medium font-['Outfit'] text-slate-900 mt-8 mb-3">9. Trasferimento di dati verso Paesi extra SEE</h3>
          <p className="text-slate-600 leading-relaxed">
            I dati sono trattati prevalentemente all'interno dello Spazio Economico Europeo. Qualora, per ragioni tecniche o organizzative, alcuni fornitori comportino trasferimenti di dati verso Paesi non appartenenti allo Spazio Economico Europeo, tali trasferimenti avverranno nel rispetto della normativa applicabile e mediante gli strumenti previsti dal GDPR.
          </p>

          <h3 className="text-lg font-medium font-['Outfit'] text-slate-900 mt-8 mb-3">10. Periodo di conservazione</h3>
          <p className="text-slate-600 leading-relaxed">I dati personali sono conservati per il tempo strettamente necessario al perseguimento delle finalità per le quali sono stati raccolti. In particolare:</p>
          <ul className="text-slate-600 space-y-2 list-disc pl-6">
            <li>dati inviati tramite richieste di contatto: fino a 12 mesi dalla gestione della richiesta, salvo ulteriore necessità amministrativa o difensiva;</li>
            <li>dati tecnici e log di sicurezza: per il tempo strettamente necessario alla sicurezza e al corretto funzionamento del sito, salvo esigenze di accertamento di illeciti;</li>
            <li>dati trattati per obblighi di legge: per il periodo previsto dalla normativa applicabile.</li>
          </ul>

          <h3 className="text-lg font-medium font-['Outfit'] text-slate-900 mt-8 mb-3">11. Diritti dell'interessato</h3>
          <p className="text-slate-600 leading-relaxed">L'interessato può esercitare, nei limiti previsti dalla normativa, i seguenti diritti:</p>
          <ul className="text-slate-600 space-y-2 list-disc pl-6">
            <li>accesso ai propri dati personali;</li>
            <li>rettifica dei dati inesatti;</li>
            <li>cancellazione dei dati;</li>
            <li>limitazione del trattamento;</li>
            <li>opposizione al trattamento;</li>
            <li>portabilità dei dati, ove applicabile;</li>
            <li>revoca del consenso, ove il trattamento si fondi sul consenso;</li>
            <li>proposizione di reclamo al Garante per la protezione dei dati personali.</li>
          </ul>
          <p className="text-slate-600 leading-relaxed mt-2">
            Le richieste possono essere inviate ai recapiti del Titolare sopra indicati.
          </p>

          <h3 className="text-lg font-medium font-['Outfit'] text-slate-900 mt-8 mb-3">12. Dati relativi alla salute</h3>
          <p className="text-slate-600 leading-relaxed">
            Il sito ha finalità prevalentemente informativa e di primo contatto. Gli utenti sono invitati a non trasmettere tramite il sito dati sanitari non necessari, referti, immagini cliniche o informazioni mediche dettagliate, salvo ciò sia espressamente richiesto e gestito con appositi strumenti e specifiche informative. Eventuali trattamenti di dati relativi alla salute effettuati nel contesto del rapporto professionale sanitario saranno disciplinati secondo la normativa applicabile e secondo le informative rese nel relativo contesto.
          </p>

          <h3 className="text-lg font-medium font-['Outfit'] text-slate-900 mt-8 mb-3">13. Cookie e strumenti di tracciamento</h3>
          <p className="text-slate-600 leading-relaxed">
            Il sito può utilizzare cookie tecnici o strumenti strettamente necessari al suo funzionamento. La presente informativa non copre eventuali cookie di profilazione, analytics non assimilabili ai tecnici o altri strumenti di tracciamento avanzato, per i quali sarebbe necessaria una specifica cookie policy e, ove richiesto, un meccanismo di consenso conforme alla normativa vigente.
          </p>

          <h3 className="text-lg font-medium font-['Outfit'] text-slate-900 mt-8 mb-3">14. Link a siti o servizi di terzi</h3>
          <p className="text-slate-600 leading-relaxed">
            Il sito può contenere collegamenti a siti, servizi o piattaforme di terzi. Il Titolare non è responsabile dei trattamenti effettuati da tali soggetti esterni, che restano disciplinati dalle rispettive informative privacy.
          </p>

          <h3 className="text-lg font-medium font-['Outfit'] text-slate-900 mt-8 mb-3">15. Modifiche alla presente informativa</h3>
          <p className="text-slate-600 leading-relaxed">
            Il Titolare si riserva il diritto di modificare o aggiornare la presente Privacy Policy in qualsiasi momento. Le modifiche saranno pubblicate su questa pagina con indicazione della data di ultimo aggiornamento.
          </p>
        </div>

        {/* Footer */}
        <div className="px-8 py-6 border-t border-slate-200 bg-slate-50 rounded-b-3xl">
          <button
            onClick={onClose}
            className="bg-gradient-to-r from-teal-500 to-emerald-800 text-white rounded-full px-8 py-3 font-medium hover:opacity-90 transition-all"
            data-testid="privacy-close-bottom-btn"
          >
            Chiudi
          </button>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
